const { mergeMap } = require('rxjs/operators')
const { ofType } = require('redux-observable')

const { partner: partnerApi } = require('@doctoroncallcom/api')
const {
  GET_PARTNER_LIST,
  GET_PARTNER,
  CREATE_PARTNER,
  UPDATE_PARTNER,
  DELETE_PARTNER,

  // for doctor/patient app
  GET_PARTNER_DATA,
} = require('./constants')

const {
  getPartnerListSuccess,
  getPartnerListError,
  getPartnerSuccess,
  getPartnerError,
  createPartnerSuccess,
  createPartnerError,
  updatePartnerSuccess,
  updatePartnerError,
  deletePartnerSuccess,
  deletePartnerError,

  // for doctor/patient app
  getPartnerDataSuccess,
  getPartnerDataError,
} = require('./actions')

const getPartnerList = (action$, state$, { api }) => action$.pipe(
  ofType(GET_PARTNER_LIST),
  mergeMap(action => partnerApi.getPartnerListApi(api, {
    skip: action.payload.skip,
    take: action.payload.take,
    name: action.payload.name,
    search: action.payload.search,
  })
    .then(response => getPartnerListSuccess(response.data))
    .catch(error => getPartnerListError(error))),
)

const getPartner = (action$, state$, { api }) => action$.pipe(
  ofType(GET_PARTNER),
  mergeMap(action => partnerApi.getPartnerApi(api, action.payload.id)
    .then(response => getPartnerSuccess(response.data))
    .catch(error => getPartnerError(error))),
)

const createPartner = (action$, state$, { api }) => action$.pipe(
  ofType(CREATE_PARTNER),
  mergeMap(action => partnerApi.createPartnerApi(api, action.payload.partnerData)
    .then(response => createPartnerSuccess(response.data))
    .catch(error => createPartnerError(error))),
)

const updatePartner = (action$, state$, { api }) => action$.pipe(
  ofType(UPDATE_PARTNER),
  mergeMap(action => partnerApi.updatePartnerApi(api, action.payload.id, action.payload.partnerData)
    .then(response => updatePartnerSuccess(response.data))
    .catch(error => updatePartnerError(error))),
)

const deletePartner = (action$, state$, { api }) => action$.pipe(
  ofType(DELETE_PARTNER),
  mergeMap(action => partnerApi.deletePartnerApi(api, action.payload.id)
    .then(response => deletePartnerSuccess(response.data))
    .catch(error => deletePartnerError(error))),
)

const getPartnerData = (action$, state$, { api }) => action$.pipe(
  ofType(GET_PARTNER_DATA),
  mergeMap(action => partnerApi.getPartnerDataApi(api, {
    partnerId: action.payload.id,
  })
    .then(response => getPartnerDataSuccess(response.data))
    .catch(error => getPartnerDataError(error))),
)

module.exports = {
  getPartnerList,
  getPartner,
  createPartner,
  updatePartner,
  deletePartner,

  // for doctor/patient app
  getPartnerData,
}
